import { useEffect } from "react";
import { useBlocker } from "react-router-dom";

export function useUnsavedWarning(hasUnsavedChanges) {
  const blocker = useBlocker(hasUnsavedChanges);

  useEffect(() => {
    if (!blocker || blocker.state !== "blocked") return; // only run when blocked

    const proceed = window.confirm(
      "You have unsaved changes. Are you sure you want to leave?"
    );

    if (proceed) {
      blocker.proceed(); // continue navigation
    } else {
      blocker.reset(); // cancel navigation
    }
  }, [blocker]);

  // refresh / tab close
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (!hasUnsavedChanges) return;
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [hasUnsavedChanges]);
}
